import type { TemplateProps } from '../templates/types';
import { Header } from './Header';
import { MessageList } from './MessageList';
import { InputArea } from './InputArea';
import { LeadForm } from './LeadForm';
import { useLeadCapture } from '../lib/useLeadCapture';
import type { WidgetConfig } from '../lib/types';

type DefaultPanelProps = TemplateProps & {
  className: string;
  renderHeader?: (config: WidgetConfig, onClear: () => void, onClose: () => void) => preact.JSX.Element;
};

export function DefaultPanel(props: DefaultPanelProps): preact.JSX.Element {
  const { config, siteId, apiBase, token, accentColor } = props;

  const { showLeadForm, leadCaptureConfig, handleLeadSubmitted } = useLeadCapture(
    siteId,
    config.lead_capture,
    props.onLeadConversation,
  );

  return (
    <div class={props.className} onClick={(e: Event) => e.stopPropagation()}>
      {props.renderHeader
        ? props.renderHeader(config, props.onClear, props.onClose)
        : <Header config={config} onClear={props.onClear} onClose={props.onClose} />}
      {showLeadForm ? (
        <LeadForm
          config={leadCaptureConfig!}
          apiBase={apiBase}
          token={token}
          siteId={siteId}
          accentColor={accentColor}
          onSubmitted={handleLeadSubmitted}
        />
      ) : (
        <>
          <MessageList
            config={config}
            messages={props.messages}
            isSending={props.isSending}
            streamContent={props.streamContent}
            error={props.error}
            onSend={props.onSend}
            onRetry={props.onRetry}
          />
          <InputArea
            onSend={props.onSend}
            onInteraction={props.onInteraction}
            disabled={props.isSending}
          />
        </>
      )}
    </div>
  );
}
